import React, { useEffect, useState } from "react";
import "./../assets/sass/_login.scss";
import "./../assets/sass/style.css";
import "./FontAwesome/FontAwesome";
import { Link } from "react-router-dom";
import axios from "axios";
import { API_Link, validateHeader } from "../commons/Constants";
import { IoEyeOutline, IoEyeOffOutline } from "react-icons/io5";
import loginvideo from "./../assets/img/MISR-Login-Page Simulation.mp4";

function SignUp({ login_page_bg, short_title, sponsor_logo }) {

  const [confirmPassword, setConfirmPassword] = useState("");
  const [cPassError, setCPassError] = useState("");
  const [error_message, setMessage] = useState("");
  const MD5hash = validateHeader();
  const [user, setUser] = useState({
    name: "",
    lastname: "",
    email: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const { name, email, password } = user;

  const handleChange = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    signup(user);
  };

  const signup = (data) => {
    axios
      .post(`${API_Link}register`, data, {
        headers: {
          "misr-auth": MD5hash,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("Response from server:", response);
        localStorage.setItem("user", JSON.stringify(response.data));
        window.location.href = response.data.role.landingpage;
      })
      .catch(function (error) {
        setMessage(error.response.data.error_message);
        console.log(error.response.data.error_message);
      });
  };

  const handleConfirmPassword = (e) => {
    setConfirmPassword(e.target.value);
    if (password != e.target.value) {
      setCPassError(" Confirm Password should be match with Password");
      console.log("password not matcch");
    } else {
      setCPassError("");
      console.log("");
    }
  };

  useEffect(() => {
    localStorage.removeItem("loginError");
    localStorage.setItem("pageId", "1001");
  }, []);

  return (
    <div>
      <div  className="login--content">
        {/* <div className="left--side d-flex justify-content-center">
          <div>
            <video
              autoPlay
              muted
              loop
              className="img-fluid2 video"
              style={{ boxShadow: "2px 2px 10px #00000029" }}
            >
              <source src={loginvideo} type="video/mp4" />
            </video>
          </div>
        </div> */}
        <div className="right--side d-flex justify-content-center">
          <div className="right--side">
            <div className="login--box">
              <h1 className="login--box--heading">SIGN UP</h1>
              <span className="welcome">Welcome to {short_title}</span>

              <form
                className="login-sigUp-font"
                onSubmit={(e) => handleSubmit(e)}
              >
                <div className="form-group">
                  <div className="row">
                    <div className="col">
                      <input
                        type="text"
                        className="form-control custom--form--control"
                        name="name"
                        value={name}
                        onChange={(e) => {
                          handleChange(e);
                          setMessage("");
                          setCPassError("");
                        }}
                        placeholder=" Name"
                      />
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <input
                    type="email"
                    className="form-control custom--form--control"
                    name="email"
                    value={email}
                    onChange={(e) => {
                      handleChange(e);
                      setMessage("");
                      setCPassError("");
                    }}
                    placeholder="Email"
                  />
                  <i className="fas fa-user"></i>
                </div>

                <div className="form-group">
                  <input
                    type={showPassword ? "text" : "password"}
                    className="form-control custom--form--control"
                    name="password"
                    value={password}
                    onChange={(e) => {
                      handleChange(e);
                      setMessage("");
                      setCPassError("");
                    }}
                    placeholder="Password"
                  />
                  <i className="fas fa-key"></i>
                  <div
                    className="signup-pass-icon-toggle"
                    onClick={togglePasswordVisibility}
                  >
                    {showPassword ? (
                      <IoEyeOutline size={25} />
                    ) : (
                      <IoEyeOffOutline size={25} />
                    )}
                  </div>
                </div>

                <div className="form-group">
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    className="form-control custom--form--control"
                    name="confirmpassword"
                    value={confirmPassword}
                    onChange={(e) => {
                      handleConfirmPassword(e);
                      setMessage("");
                      setCPassError("");
                    }}
                    autoComplete="current-password"
                    placeholder="Confirm Password"
                  />
                  <i className="fas fa-key"></i>
                  <div
                    className="signup-pass-icon-toggle"
                    onClick={toggleConfirmPasswordVisibility}
                  >
                    {showConfirmPassword ? (
                      <IoEyeOutline size={25} />
                    ) : (
                      <IoEyeOffOutline size={25} />
                    )}
                  </div>
                </div>
                <div className="text-danger alert-danger ms-1 mt-1 ">
                  {error_message ? error_message : ""}
                </div>
                <div className="text-danger alert-danger ms-1 mt-1">
                  {cPassError}
                </div>

                <div className="form-group text-center">
                  <span className="position-relative">
                    <input
                      type="submit"
                      value="SIGN UP"
                      className="submit--btn"
                    />
                    <i className="fa-solid fa-arrow-right-from-bracket"></i>
                  </span>
                </div>
                <div className="d-flex justify-content-between mt-3 ">
                  <div className="d-flex create-acount-link">
                    <div className="">Already have an account?</div>
                    <span className="ms-2">
                      <Link to="/" className="Sign--up">
                        Login here
                      </Link>
                    </span>
                  </div>
                  <div className="box--logo ">
                    <img src={sponsor_logo} alt="" />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SignUp;
